import React from 'react';
import {
  layoutBoxToStyle,
  parseRgbBackground,
  resolveTemplateContent,
} from '../utils/templateParser';
import './AlertTemplate.css';

function LayerImage({ layer }) {
  return (
    <img
      src={layer.url}
      alt=""
      className="alert-template__layer-img"
      style={layoutBoxToStyle(layer)}
      draggable={false}
    />
  );
}

export default function AlertTemplateRenderer({ template, scale = 1 }) {
  if (!template) return null;

  const { width, height } = template.dimensions;
  const applayout = template.applayout || {};
  const content = resolveTemplateContent(template);
  const bg = parseRgbBackground(applayout.backgroundColor);

  const images = [...(applayout.imageLayout || [])].sort(
    (a, b) => (a.zorder || 0) - (b.zorder || 0),
  );
  const editable = (applayout.editableLayout || [])[0];

  return (
    <div
      className="alert-template__viewport"
      style={{
        width: width * scale,
        height: height * scale,
      }}
    >
      <div
        className="alert-template__canvas"
        style={{
          width,
          height,
          transform: `scale(${scale})`,
          background: bg,
        }}
      >
        {images.map((layer, index) => (
          <LayerImage key={`${layer.url}-${index}`} layer={layer} />
        ))}

        <div
          className="alert-template__banner"
          style={{
            top: 0,
            left: 0,
            width: '100%',
            height: '12.6%',
            background: content.bannerFill,
            zIndex: 10,
          }}
        >
          <p className="alert-template__banner-title">{content.bannerTitle}</p>
          <p className="alert-template__banner-subtitle">{content.bannerSubtitle}</p>
        </div>

        {editable && (
          <div
            className="alert-template__editable"
            style={{
              ...layoutBoxToStyle(editable),
              zIndex: 20,
            }}
          >
            <p className="alert-template__message-title">{content.messageTitle}</p>
            {content.messageBody ? (
              <p className="alert-template__message-body">{content.messageBody}</p>
            ) : null}
          </div>
        )}
      </div>
    </div>
  );
}
